import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>EFC Buseck</h3>
            <p>Offizieller Fanclub für alle Eintracht-Fans aus Buseck und Umgebung.</p>
          </div>

          <div className="footer-section">
            <h4>Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/spiele">Alle Spiele</Link></li>
              <li><Link to="/news">News</Link></li>
              <li><Link to="/ueber-uns">Über uns</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Rechtliches</h4>
            <ul>
              <li><Link to="/impressum">Impressum</Link></li>
              <li><Link to="/datenschutz">Datenschutz</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Kontakt</h4>
            <p>E-Mail: info@efc-buseck.de</p>
            <p>Telefon: +49 (0) 6408 123456</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 EFC Buseck. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
